export default "<spec-app-type5-boolean-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type5-boolean-table>\n";